import { useId } from 'react';

import { useCncFlyInState } from '../../hooks/useCncFlyInState';
import useModal from '../../hooks/useModal';
import { useAppSelector } from '../../hooks/useThunkDispatch';
import { storeSelectors } from '../../selectors/storeSelectors';
import { RecipeModalType } from '../../store/structureDefinitions/modalState';
import tracking from '../../tracking/tracking';

export const useRecipeModal = (recipeId: string, recipeName: string) => {
    const id = useId();
    const modalActions = useModal(RecipeModalType.RecipeModal, undefined, `${recipeId}_${id}`);

    const hasActiveStoreSelection = useAppSelector(storeSelectors.hasActiveStoreSelection);

    const { initCnc } = useCncFlyInState();

    const tryOpen = () => {
        tracking.ecommerce.recipes.interaction(
            'Receptsida - Öppna receptmodal',
            recipeName,
            recipeName,
        );

        if (!hasActiveStoreSelection) {
            initCnc();
        } else {
            modalActions.open();
        }
    };

    return { ...modalActions, tryOpen };
};
